import { RootState } from 'app/store';

export const selectAppLocale = (state: RootState): string =>
  state.locale.locale;
